"use client"

import { api } from "@/lib/api"
import { STALE_LONG } from "./queryConfig.constants"

export function useIsSetupAppVisible(): boolean {
    const { data } = api.setup.isAppShown.useQuery(undefined, {
        staleTime: STALE_LONG,
    })
    return data === true
}
